import { useEffect } from "react";

const BASE = "https://harrisonlitigationteam.com";

export const setMetaTag = (attr, key, content) => {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const setCanonical = (path) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = BASE + path;
};

export const applyPageMeta = (title, description) => {
  if (!title) return;
  document.title = title;
  setMetaTag("property", "og:title", title);
  if (description) {
    setMetaTag("name", "description", description);
    setMetaTag("property", "og:description", description);
  }
  setMetaTag("property", "og:url", BASE + window.location.pathname);
  setCanonical(window.location.pathname);
};

export default function usePageMeta(title, description, jsonLd, noindex = false) {
  useEffect(() => {
    if (!title) return;
    applyPageMeta(title, description);
    if (noindex) document.querySelector('link[rel="canonical"]')?.remove();
    setMetaTag("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let ldTag;
    if (jsonLd) {
      ldTag = document.createElement("script");
      ldTag.type = "application/ld+json";
      ldTag.dataset.pageJsonld = "true";
      ldTag.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ldTag);
    }
    return () => {
      if (ldTag) ldTag.remove();
    };
  }, [title, description, noindex]);
}
